<template>
  <v-stepper-content step="2" :class="$vuetify.breakpoint.name === 'xs' ? 'px-0' : ''">
    <v-col
      cols="12"
      :class="$vuetify.breakpoint.name !== 'sm' ? 'd-flex justify-center mx-0 px-0' : 'd-flex justify-center'"
    >
      <v-card
        flat
        outlined
        rounded="lg"
        :max-width="$vuetify.breakpoint.name === 'xs' ? '95vw' : '75vw'"
        min-height="500px"
      >
      <v-row :class="$vuetify.breakpoint.name === 'xs' ? 'mt-8 mx-1' : 'mt-8 mx-5'">
          <v-col cols="12">
            <div class="text-md-h4 text-h5" :style="textColor">General Company Information</div>
          </v-col>

          <v-col cols="12" class="mt-8">
            <v-text-field
              outlined
              label="*Legal Entity Name"
              class="rounded-lg"
              hide-details
              v-model="legalName"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Doing Business As/Trade Name"
              hint="If different than above"
              persistent-hint
              class="rounded-lg"
              v-model="altLegalName"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Years in Business"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="yearsInBusiness"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="Years at location"
              class="rounded-lg"
              hide-details
              type="number"
              v-model="yearsAtLocation"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Owner/Member/Partner(s) Name(s) and Percentage(s)"
              class="rounded-lg"
              hide-details
              v-model="ownerName"
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-text-field
              outlined
              label="Description of Business Operations"
              class="rounded-lg"
              hide-details
              v-model="description"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              outlined
              label="*FEIN/Tax ID #"
              class="rounded-lg"
              hide-details
              v-model="fedId"
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="6">
            <v-combobox
              v-model="corporationType"
              :items="corpTypes"
              persistent-hint
              hint="If LLC, Select Tax Classification"
              outlined
              label="Corporation Type"
              class="rounded-lg"
            ></v-combobox>
          </v-col>
          <BtnContinue />
        </v-row>
      </v-card>
    </v-col>
  </v-stepper-content>
</template>

<script>
import BtnContinue from '../../btnContinue.vue';

export default {
  name: 'StepTwo',
  components: {
    BtnContinue,
  },
  data: () => ({
    select: null,
  }),
  computed: {
    textColor() {
      if (this.$vuetify.theme.dark) {
        return 'color: #ffffff';
      }

      return 'color: #2a4f66';
    },
    corpTypes() {
      return this.$store.state.corporationTypes;
    },
    contactType() {
      return this.$store.state.prospectPacket.companyInfo.ownerContactType;
    },
    contact: {
      get() {
        return this.$store.state.prospectPacket.contacts.find((x) => x.contactType === this.contactType);
      },
      set(value) {
        this.$store.state.commit('updateContactObject', value);
      },
    },
    legalName: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.legalName;
      },
      set(value) {
        this.$store.commit('updateCompanyLegalName', value);
      },
    },
    altLegalName: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.legalNameAlt;
      },
      set(value) {
        this.$store.commit('updateCompanyLegalNameAlt', value);
      },
    },
    yearsInBusiness: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.yearsInBusiness;
      },
      set(value) {
        this.$store.commit('updateCompanyYearsInBusiness', Number(value));
      },
    },
    yearsAtLocation: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.yearsAtLocation;
      },
      set(value) {
        this.$store.commit('updateCompanyYearsAtLocation', Number(value));
      },
    },
    ownerName: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.ownerNames;
      },
      set(value) {
        this.$store.commit('updateCompanyOwnerNames', value);
      },
    },
    description: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.descriptionOfOperations;
      },
      set(value) {
        this.$store.commit('updateCompanyDescription', value);
      },
    },
    fedId: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.fedId;
      },
      set(value) {
        this.$store.commit('updateFedId', value);
      },
    },
    corporationType: {
      get() {
        return this.$store.state.prospectPacket.companyInfo.corporationType;
      },
      set(value) {
        this.$store.commit('updateCorporationType', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
